<template>
  <IQOSModal @backdropClick="$emit('cancel')">

      <template #title> 
          <div class="red-4-color danger-title">
              <BaseIcon icon="allert" class="mr-8" size="sm2"/>
              {{ title || $t('danger_confirm_modal.default_title')}}
          </div>
      </template>

        <div class="v1-grey-3-color"><slot/></div>    

      <template #actions> 
          <BaseButton @click="$emit('cancel')" size="md" variant="secondary" class="w-100" :color="useGreenCancel ? 'green-5' : 'v1-grey-5'">
                {{ cancelButton || $t( 'danger_confirm_modal.default_cancel') }}
          </BaseButton>

          <BaseButton @click="$emit('confirm')" size="md" variant="secondary" class="w-100" color="red-4">
                {{ confirmButton || $t('danger_confirm_modal.default_confirm') }}
          </BaseButton>
      </template>   
  </IQOSModal>
</template>

<script>
export default {
    props: {
        cancelButton: {
            type: String
        },
        confirmButton: {
            type: String
        },
        useGreenCancel: {
            type: Boolean,
            default: false
        },
        title: String
    }
}
</script>

<style scoped>
.danger-title {
    display: flex;
    align-items: center;
    align-self: center;
    align-content: center;
}
</style>